// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c3540f6","455":"d26fe7a6","879":"925f5ef3"}[chunkId] + ".chunk.js";
};